import { API_BASE } from "../constants";

export class ContentConstants {
  public static CONTENT_ITEM_SINGLE = API_BASE + "/content-item/{ciId}";
}
